import * as React from 'react';

import FieldTextInput from 'components/FieldTextInput';
import FormInput from 'components/FormInput';
import FormInputSelect from 'components/FormInputSelect';
import MaterialButton from 'components/MaterialButton';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { getTimeZoneOptions } from 'utils/timeZones';

import styles from './CreateWorkspace.module.css';

interface Props {
  submitting: boolean;
  pristine: boolean;
  invalid: boolean;
  change: (field: string, value: any) => void;
  handleSubmit?: MouseEvent | any;
}

const CreateWorkspace: React.FC<Props> = (props) => {
  const { handleSubmit, submitting, pristine, invalid } = props;

  const { t } = useTranslation();

  const timeZoneList = getTimeZoneOptions();

  const getData = () => {
    return timeZoneList.map((tz) => {
      return {
        value: tz.name,
        label: tz.reformatName,
      };
    });
  };

  return (
    <div>
      <div className={styles.sectionContainer}>
        <Field
          name="name"
          component={FieldTextInput}
          fullWidth
          label={t('workspace.name')}
          required
        />
        <Field
          name="slug"
          component={FieldTextInput}
          fullWidth
          label={t('workspace.slug')}
          required
        />
        <Field
          name="defaultTimezone"
          component={FormInput}
          inputComponent={FormInputSelect}
          key="defaultTimezone"
          className={styles.inputSelect}
          options={timeZoneList ? getData() : null}
          hideSelectedOptions={false}
          placeholder={t('workspace.defaultTimezone')}
          closeMenuOnSelect={true}
          required
          value={(val) => val.value}
        />
      </div>

      <div className={styles.buttonContainer}>
        <MaterialButton
          variant="outlined"
          disabled={pristine || invalid || submitting}
          onClick={handleSubmit}
          soft
          teal
        >
          Submit
        </MaterialButton>
      </div>
    </div>
  );
};

export default CreateWorkspace;
